<a
  mat-icon-button
  [routerLink]="routerLink"
  matTooltip="{{ 'ui.lock.tooltips.un.lock.button' | translate }}">
  <mat-icon>key</mat-icon>
</a>
